'use client';

import React, { useState, useRef } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import TopLogo from './images/toplogo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [desktopDropdownOpen, setDesktopDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownTimer = useRef(null);

  // Scroll only when triggered manually
  const scrollToContact = () => {
  if (location.pathname === '/') {
    const el = document.getElementById('contact');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  } else {
    navigate('/', { state: { scrollToContact: true } });
  }
  setMenuOpen(false); // Close mobile menu
};


  // Desktop dropdown handlers
  const handleMouseEnter = () => {
    clearTimeout(dropdownTimer.current);
    setDesktopDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    dropdownTimer.current = setTimeout(() => {
      setDesktopDropdownOpen(false);
    }, 50); // Delay before closing
  };

  return (
    <nav className="bg-white w-full fixed top-0 left-0 z-50 shadow-sm">
      <div className="flex items-center justify-between px-6 h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img src={TopLogo} alt="Logo" className="h-20 w-auto" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex gap-x-10 items-center mr-10">
          <Link to="/" className="text-gray-700 hover:text-orange-500 font-medium">Home</Link>
          <Link to="/about" className="text-gray-700 hover:text-orange-500 font-medium">About</Link>

          {/* Desktop Dropdown */}
          <div
            className="relative"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500 font-medium">
              Services
              <ChevronDown className={`w-4 h-4 mt-1 transition-transform ${desktopDropdownOpen ? 'rotate-180' : ''}`} />
            </button>
            {desktopDropdownOpen && (
              <div className="absolute left-0 mt-2 w-48 bg-white border rounded shadow-lg z-20">
                <Link to="/automobile" className="block px-4 py-2 hover:text-orange-500 font-medium">Automobile</Link>
                <Link to="/switchyard" className="block px-4 py-2 hover:text-orange-500 font-medium">Locomotive</Link>
                <Link to="/switchgear" className="block px-4 py-2 hover:text-orange-500 font-medium">Panel Design</Link>
              </div>
            )}
          </div>

          <button onClick={scrollToContact} className="text-gray-700 hover:text-orange-600 font-medium">Contact</button>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-gray-700 focus:outline-none">
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow px-4 py-4 space-y-2">
          <Link to="/" className="block text-gray-700 hover:text-orange-500">Home</Link>
          <Link to="/about" className="block text-gray-700 hover:text-orange-500">About</Link>

          {/* Mobile Dropdown */}
          <div>
            <button
              onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
              className="flex items-center justify-between w-full text-gray-700 hover:text-orange-500 font-medium focus:outline-none"
            >
              <span>Services</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${mobileDropdownOpen ? 'rotate-180' : ''}`} />
            </button>
            {mobileDropdownOpen && (
              <div className="pl-4 mt-2 space-y-1">
                <Link to="/automobile" className="block text-gray-700 hover:text-orange-500">Automobile</Link>
                <Link to="/switchyard" className="block text-gray-700 hover:text-orange-500">Locomotive</Link>
                <Link to="/switchgear" className="block text-gray-700 hover:text-orange-500">Panel Design</Link>
              </div>
            )}
          </div>

          <button onClick={scrollToContact} className="block text-gray-700 hover:text-orange-500">Contact</button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
